// tslint:disable: max-line-length
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwSecurityUserService } from '@devwareapps/devware-cap';
import { TemplateEntity, AppMetaDataLookups, RequestEntity, AppMetaDataService, CompanyEntity, RequestEquipmentEntity } from 'src/app/meta-data/app-meta-data.service';
import { EquipRequestService } from '../../services/equip-request.service';
@DwComponent({
  name: 'Read Only Equipment List',
  parentItemName: 'RequestEquipment',
  componentType: DwComponentType.formSection,
})
@Component({
  selector: 'app-equip-grid-readonly-section',
  templateUrl: './equip-grid-readonly-section.component.html',
  styleUrls: ['./equip-grid-readonly-section.component.scss']
})
export class EquipGridReadonlySectionComponent extends DwSectionBaseComponent<DwComponentSectionPreference> implements OnInit {


  equipment: [];
  data: RequestEquipmentEntity[];

  securityContext: any;

/*
  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,

     private dwSecurityService: DwSecurityUserService,
    private messageService:  DwMessagingService,
    private equipRequestService: EquipRequestService) {
      super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

      this.securityContext = this.dwSecurityService.securityContext;
    }
 */


  contextChanged() {

    this.context.data.subscribe((data: RequestEntity) => {
      if (data) {
        this.data = data.RequestEquipment;

        //console.log(data);
      }
    });

  }

}
